import React, { useEffect, useState } from 'react';
import { BsFillInfoCircleFill } from 'react-icons/bs';
import { FaUser, FaQuestion } from 'react-icons/fa';
import { FaFilm } from "react-icons/fa6";
import { TbLivePhotoFilled } from "react-icons/tb";
import logo from '../assets/TicketInfo New Logo.png';
import icon from '../assets/ticket-icon.png';
import logo_for_light from '../assets/Light Logo.png';
import icon_for_light from '../assets/Light Icon.png';
// import logo from '..//logo2.png';
import { NavLink } from "react-router-dom";
import { BiArrowFromLeft } from 'react-icons/bi';
import { IoSettings } from 'react-icons/io5';

export default function Sidebar({ openSidebarToggle, OpenSidebar, collapsed, setCollapsed }) {

  const [theme, setTheme] = useState(document.body.getAttribute('data-bs-theme') || 'light');

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setTheme(document.body.getAttribute('data-bs-theme'));
    });

    observer.observe(document.body, { attributes: true, attributeFilter: ['data-bs-theme'] });

    return () => observer.disconnect();
  }, []);

  return (
    <aside id='sidebar' className={`${openSidebarToggle ? 'sidebar-responsive' : ''} ${collapsed ? 'collapsed' : ''}`}>
      <div className='sidebar-sticky'>
        <div className="sidebar-title">
          <div className="sidebar-brand">
            <img src={theme === 'dark' ? icon : icon_for_light} className='logo-icon' alt="" width="30px" />
            <img src={theme === 'dark' ? logo : logo_for_light} className='logo' alt="" width="170px" />
            <BiArrowFromLeft className={`sidebar-toggle ${collapsed ? 'rotate' : ''}`}
              onClick={() => setCollapsed(!collapsed)} />
          </div>
          {/* <span className='icon close_icon' onClick={() => OpenSidebar()}>X</span> */}
        </div>

        <div className='d-flx justify-content-between'>
          <ul className='sidebar-list'>
            <li className='sidebar-list-item'>
              <NavLink to="/livefeed" className={({ isActive }) => isActive ? 'active' : ''} aria-label='Live Feed'>
                <TbLivePhotoFilled className='icon' />
                <span className='text'>Live Feed</span>

              </NavLink>
            </li>
            <li className='sidebar-list-item'>
              <NavLink to="/event-news" className={({ isActive }) => isActive ? 'active' : ''} aria-label='Dashboard'>
                <FaFilm className='icon' />
                <span className='text'>Dashboard</span>
              </NavLink>
            </li>
            <li className='sidebar-list-item'>
              <NavLink to="/upcoming-events" className={({ isActive }) => isActive ? 'active' : ''} aria-label='Upcoming Events'>
                <BsFillInfoCircleFill className='icon' />
                <span className='text'>Upcoming Events</span>
              </NavLink>
            </li>
            <li className='sidebar-list-item'>
              <NavLink to="https://ticketsinfo.net/Subscription.aspx" className={({ isActive }) => isActive ? 'active' : ''} aria-label='Subscription'>
                <FaUser className='icon' />
                <span className='text'>Subscription</span>
              </NavLink>
            </li>
            <li className='sidebar-list-item'>
              <NavLink to="/settings" className={({ isActive }) => isActive ? 'active' : ''} aria-label='Settings'>
                {/* <BsFillGearFill className='icon' /> */}
                <IoSettings className='icon' />
                <span className='text'>Settings</span>
              </NavLink>
            </li>
            <li className='sidebar-list-item'>
              <NavLink to="/help" className={({ isActive }) => isActive ? 'active' : ''} aria-label='Help'>
                <FaQuestion className='icon' />
                <span className='text'>Help</span>
              </NavLink>
            </li>
          </ul>
        </div>


      </div>

    </aside>
  )
}

